import type { Routes } from '@angular/router';

import { authGuard } from '@core/auth';
import { devGuard } from '@core/dev';

import { ShellComponent } from '@features/shell';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@features/login/login.component').then((c) => c.LoginComponent),
  },
  {
    path: 'examples',
    canMatch: [devGuard],
    loadComponent: () =>
      import('@features/examples/examples.component').then((c) => c.ExamplesComponent),
  },
  {
    path: '',
    component: ShellComponent,
    canMatch: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        data: { preload: true },
        loadComponent: () =>
          import('@features/dashboard/dashboard.component').then((c) => c.DashboardComponent),
      },
      {
        path: 'lists',
        data: { preload: true },
        loadChildren: () => import('@features/lists/lists.routes').then((m) => m.LISTS_ROUTES),
      },
      {
        path: 'tasks-activities',
        data: { preload: true },
        loadChildren: () =>
          import('@features/tasks-activities/tasks-activities.routes').then(
            (m) => m.TASKS_ACTIVITIES_ROUTES,
          ),
      },
    ],
  },
];
